import { gql } from '../../../../__generated__';

export const DISCONNECT_CALENDER = gql(`
  mutation DisconnectCalender {
  disconnectCalender {
    message
  }
}`);
